import { useCallback, useState } from "react";
import { Box, TextField, styled } from "@mui/material";
import * as tokens from "@shape-ds/tokens";
import { PrimaryButton } from "../Button";
import { ShapeLogo } from "../ShapeLogo";
import { LoginProps } from "./types";

const Background = styled("div")(() => ({
  width: "100%",
  height: "100vh",
  display: "flex",
  alignItems: "center",
}));

const LogoContainer = styled("div")({
  width: "100%",
  height: "50px",
  display: "flex",
  justifyContent: "center",
  marginBottom: tokens.SPACING_MD,
});

const Login = ({ onSubmit, topElement, buttonLabel, contained = true }: LoginProps) => {
  const [email, setEmail] = useState<string>("");
  const handleEmail = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  }, []);
  return (
    <Background>
      <Box
        style={{ width: contained ? "30%" : "100%", margin: "0 auto", padding: tokens.SPACING_XL }}
      >
        {topElement ? (
          topElement
        ) : (
          <LogoContainer>
            <ShapeLogo />
          </LogoContainer>
        )}

        <TextField label="E-mail" fullWidth value={email} onChange={handleEmail} />
        <div style={{ marginTop: tokens.SPACING_MD }}>
          <PrimaryButton
            disabled={!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(email)}
            fullWidth
            onClick={() => onSubmit(email)}
          >
            {buttonLabel ? buttonLabel : "Prosseguir"}
          </PrimaryButton>
        </div>
      </Box>
    </Background>
  );
};

export default Login;
